import store from 'utils/store/withMiddleware'
import { WebStorage } from 'proxy-storage'
import { findApplicant } from '@hc-frontend/business'
import { CRM_MIDDLEWARE } from 'core/constants/endpoints'
import { fetchJSON, getISODate } from '@hc-frontend/utils'
import { handleResponseLead } from './handleResponseLead'
import { SFResponse } from '../types'

const sessionStorage = new WebStorage('sessionStorage')

function makePayloadLead({ hcStorage, quoteKey }) {
  const { members } = hcStorage
  const applicant = findApplicant(members)
  const dob = getISODate(applicant.dob)
  const isTest = String(hcStorage.agent_id).includes('TEST') ? 'Yes' : 'No'
  const pivotSFLeadId = sessionStorage.getItem(
    `pivotSFLeadId-${hcStorage.contact.email_address}`
  )
  const pivotJornayaLeadIdToken = sessionStorage.getItem('pivotJornayaLeadIdToken')

  const data = {
    isATest__c: isTest,
    email: hcStorage.contact.email_address,
    phone: hcStorage.contact.phone_home
      ? hcStorage.contact.phone_home.replace(/\D+/g, '')
      : '',
    address: hcStorage.contact.address || '',
    firstName: applicant.firstName,
    lastName: applicant.lastName,
    dob: dob,
    gender: applicant.gender,
    pivotSID: hcStorage.healthcareSession,
    pivotUID: hcStorage.healthcareUserId,
    utm_source: hcStorage.utm.utm_source,
    utm_medium: hcStorage.utm.utm_medium,
    utm_campaign: hcStorage.utm.utm_campaign,
    utm_term: hcStorage.utm.utm_term,
    utm_content: hcStorage.utm.utm_content,
    device: hcStorage.Device,
    agent_id: hcStorage.agent_id,
    placement: hcStorage.placement,
    houseHoldIncome: hcStorage.household.income,
    houseHoldSize: members.length,
    originalEntrancePageURL: hcStorage.landing_url,
    quoteKey,
    leadType: 'U65'
  }

  if (hcStorage.location.city) {
    data['city'] = hcStorage.location.city
    data['state_acronym'] = hcStorage.location.state_acronym
    data['state'] = hcStorage.location.state
    data['zip_code'] = hcStorage.location.zip_code
    data['county'] = hcStorage.location.county
  }

  if (pivotSFLeadId) {
    data['idLead'] = pivotSFLeadId
  }

  if (pivotJornayaLeadIdToken) {
    data['leadIdToken'] = pivotJornayaLeadIdToken
  }

  return data
}

function createLead(data): Promise<void | SFResponse> {
  return fetchJSON<SFResponse>(`${CRM_MIDDLEWARE}/lead`, {
    body: data
  }).then(response => response.parsedBody)
}

function sendLead(): Promise<SFResponse | null> {
  const { hcStorage, quoteKey } = store.getState()
  if (
    !hcStorage.contact ||
    !hcStorage.contact.email_address ||
    !hcStorage.members ||
    !hcStorage.members[0]
  ) {
    return
  }

  const data = makePayloadLead({
    hcStorage,
    quoteKey
  })
  return createLead(data).then(handleResponseLead)
}

export { sendLead, createLead, makePayloadLead }
